export interface UpdateCompanyInformationDto {
  companyName?: string;
  businessName?: string;
  companyNationalId?: string;
  companyType?: string;
  registrationNumber?: string;
  gazetteFileUrl?: string;
}

export function toUpdateCompanyInformationFormData(
  dto: UpdateCompanyInformationDto,
): FormData {
  const formData = new FormData();

  if (dto.companyName !== undefined) {
    formData.append('CompanyName', dto.companyName);
  }

  if (dto.businessName !== undefined) {
    formData.append('BusinessName', dto.businessName);
  }

  if (dto.companyNationalId !== undefined) {
    formData.append('CompanyNationalId', dto.companyNationalId);
  }

  if (dto.companyType !== undefined) {
    formData.append('CompanyType', dto.companyType);
  }

  if (dto.registrationNumber !== undefined) {
    formData.append('RegistrationNumber', dto.registrationNumber);
  }

  if (dto.gazetteFileUrl !== undefined) {
    formData.append('GazetteFileUrl', dto.gazetteFileUrl);
  }

  return formData;
}
